/**
 * 园区层级在地图散点处的展示色。
 * 侧栏「待开发园区数量」使用 `.dash-stat-card__value--pending`（index.css），色值须与本常量一致。
 */
export const PARK_COLOR_PENDING = '#d48806';

/** 地图散点描边/强调等可用的待开发色半透明形式 */
export const PARK_COLOR_PENDING_GLOW = 'rgba(212, 136, 6, 0.35)';
